import React, { useState } from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { useFieldCommentsContext, FieldCommentNote } from './fieldComments';
import { inputXs, fieldCommentAddBtn, fieldCommentAddBtnActive } from './constants';

// 不是一格 DetailItem，但仍然需要能被評論的東西——附件清單、逐題表格、
// 涵蓋公司列表。
//
// DetailItem 自己長出評論入口，因為它就是「一格值」；這個元件把同一組行為
// 借給其他版型：放在該區塊的最後一行，看起來就像那一區的便條。
//
// 沒有 provider（申請者在看）、也沒有舊意見時整個不顯示，所以任何頁面都可以
// 無條件掛上去。
//   compact   — 按鈕只寫 "Comment"。QC 的驗收表一頁幾十題，每一題後面掛一句
//               "Comment on did the engagement partner…" 比題目本身還長。
//   hoverOnly — 平時隱形，游標移到那一列才浮出來（外層要有 `group` class），
//               同 DetailItem 的規則：入口不該蓋過內容。
const FieldCommentAnchor = ({
  field, label, className = 'mt-2', compact = false, hoverOnly = false,
}) => {
  const fc = useFieldCommentsContext();
  const draft = fc ? fc.drafts[field] : undefined;
  const [editing, setEditing] = useState(draft !== undefined);

  if (!fc) return null;
  const existing = fc.existingByField[field];
  if (!existing && !fc.canComment) return null;

  return (
    <div className={className}>
      {existing && <FieldCommentNote entry={existing} />}
      {fc.canComment && !editing && (
        <button
          type="button"
          onClick={() => { setEditing(true); fc.set(field, '', label); }}
          className={`${fieldCommentAddBtn} ${hoverOnly ? '' : 'opacity-100'} inline-flex items-center gap-0.5`}
          title={`Comment on ${label}`}
        >
          <MessageSquarePlus className="w-3 h-3" /> {compact ? 'Comment' : `Comment on ${label.toLowerCase()}`}
        </button>
      )}
      {fc.canComment && editing && (
        <div className="mt-1">
          <textarea
            rows="2"
            autoFocus
            value={draft || ''}
            onChange={(e) => fc.set(field, e.target.value, label)}
            placeholder={`What needs to change about ${label.toLowerCase()}?`}
            className={inputXs}
          />
          <button
            type="button"
            onClick={() => { fc.remove(field); setEditing(false); }}
            className={`${fieldCommentAddBtnActive} mt-0.5`}
          >
            Remove Comment
          </button>
        </div>
      )}
    </div>
  );
};

export default FieldCommentAnchor;
